import { chunk, noop } from 'lodash';
import { SmallGhostButton } from '@ardoq/button';
import { FlexBox, Stack } from '@ardoq/layout';

type DatePickerGridProps = {
  activeItemId: string | null;
  items: { label: string; id: string }[];
  onSelect?: (selectedId: string) => void;
  getIsDisabled?: (selectedId: string) => boolean;
};

export const DatePickerGrid = ({
  items,
  activeItemId = null,
  onSelect = noop,
  getIsDisabled = () => false,
}: DatePickerGridProps) => (
  <Stack gap="medium">
    {chunk(items, 3).map((itemsGroup, groupIndex) => (
      <FlexBox gap="medium" key={groupIndex} justify="space-between">
        {itemsGroup.map(item => (
          <SmallGhostButton
            style={{ width: '56px', maxWidth: '56px' }}
            key={item.label}
            isFlexible
            isActive={item.id === activeItemId}
            onClick={() => onSelect(item.id)}
            isDisabled={getIsDisabled(item.id)}
          >
            {item.label}
          </SmallGhostButton>
        ))}
      </FlexBox>
    ))}
  </Stack>
);
